import { render, staticRenderFns } from "./PubLogo.vue?vue&type=template&id=f300b2ba"
import script from "./PubLogo.vue?vue&type=script&lang=js"
export * from "./PubLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports